export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5586.ed974f84.jpg";